import axios from '@/api/axios'

// const testData = {
//   allSum: 0,
//   kpkv: [],
//   status: null,
//   rozporyadnykKoshtiv: [],
//   numberDays: 1,
//   participants: 19,
//   trainers: {
//     value: 3,
//     tariffRate: 396.7,
//   },
//   judges: {
//     value: 4,
//     tariffRate: 396.7,
//   },
//   accompanying: {
//     value: 5,
//     tariffRate: 396.7,
//   },
//   food: '6',
//   residence: '7',
//   driveway: '200',
//   daily: '100',
//   prizes: '400',
//   rent: '5000',
//   organization: '600',
//   vikoviHrupysList: [
//     {
//       id: 453,
//       name: 'Дівчата',
//       type: 'vikovi-hrupy',
//       tariffRate: 396.7,
//       value: 13,
//       isCound: true,
//     },
//     {
//       id: 8,
//       name: 'Дорослі',
//       type: 'vikovi-hrupy',
//       tariffRate: 396.7,
//       value: 14,
//       isCound: false,
//     },
//     {
//       id: 255,
//       name: 'Молодь',
//       type: 'vikovi-hrupy',
//       tariffRate: 396.7,
//       value: 15,
//       isCound: false,
//     },
//   ],
//
//   sportEventId: 358,
//   sportEventName:
//     'TEST Кубок України серед чоловіків та жінок "Пул-9 " - ІІІ етап ',
// }

const getFinance = (id) => {
  return axios.get(`/sportsEvents/finances/${id}`).then((res) => res.data)
}

const createFinance = (finance) => {
    return axios.post(`/sportsEvents/finances/${finance.sportEventId}`, finance)
}

const updateFinance = (id, financeInput) => {
  return axios.put(`/finances/${id}`, financeInput)
}

const deleteFinance = (id) => {
  return axios.delete(`/finances/${id}`)
}

export default {
  getFinance,
  createFinance,
  updateFinance,
  deleteFinance,
}
